(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rz-arrivals-motion"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const stage = root.querySelector('[data-rz-stage]');
    let slides = [...root.querySelectorAll('[data-rz-slide]')];
    const priority = ['keyboards','mice','headsets','accessories'];
    function hydrate(slide) {
      const title = slide.dataset.title || '';
      slide.style.setProperty('--model-length', Math.max(4,slide.dataset.model.length));
      slide.title = title;
    }
    slides.forEach(hydrate);
    if (!slides.length) {root.hidden=true;return;}
    const dots = root.querySelector('[data-rz-dots]');
    const status = root.querySelector('[data-rz-status]');
    let category = slides[0].dataset.category, index = 0, timer, pointer = null, dragged = false;
    const memory = {};
    const group = () => slides.filter(s => s.dataset.category === category);
    const present=[...new Set(slides.map(s=>s.dataset.category))];
    const categories=[...priority.filter(c=>present.includes(c)),...present.filter(c=>!priority.includes(c))];
    category=categories[0];
    function destination(dir) {
      const next = index + dir;
      if(next >= 0 && next < group().length) return { category, index: next };
      const categoryIndex = categories.indexOf(category);
      const nextCategory = categories[(categoryIndex + dir + categories.length) % categories.length];
      const list = slides.filter(s => s.dataset.category === nextCategory);
      return { category: nextCategory, index: dir > 0 ? 0 : list.length - 1 };
    }
    function advance(dir) {
      const target = destination(dir);
      category = target.category;
      show(target.index, dir);
    }
    function renderDots() {
      dots.replaceChildren();
      slides.forEach(s => {
        const b=document.createElement('button');
        b.type='button';b.setAttribute('aria-label',s.dataset.navLabel);
        b.setAttribute('aria-current',String(s===group()[index]));
        b.addEventListener('click',()=>{
          const dir=slides.indexOf(s)>=slides.indexOf(group()[index])?1:-1;
          category=s.dataset.category;show(group().indexOf(s),dir);
        });
        dots.append(b);
      });
    }
    function show(next, dir = 1, animate = true) {
      const list = group(); if (!list.length) return;
      clearTimeout(timer); index = (next + list.length) % list.length; memory[category] = index;
      root.style.setProperty('--dir', dir);
      root.style.setProperty('--drag', '0px');
      slides.forEach(s => {
        const wasActive = s.classList.contains('is-active');
        s.classList.remove('is-active','is-entering','is-leaving');
        s.setAttribute('aria-hidden','true'); s.inert = true;
        if (wasActive && s !== list[index] && animate) s.classList.add('is-leaving');
      });
      const active = list[index];

      const image=active.querySelector('img');if(image)image.loading='eager';
      active.classList.add('is-active'); if (animate) active.classList.add('is-entering');
      active.inert = false; active.setAttribute('aria-hidden','false');
      const nextTarget = destination(1);
      const nextSlide = slides.filter(s => s.dataset.category === nextTarget.category)[nextTarget.index];
      const nextImg = nextSlide.querySelector('img');if(nextImg)nextImg.loading='eager';
      const peek = root.querySelector('[data-rz-peek]');
      if(nextImg){peek.src=nextImg.currentSrc||nextImg.src;peek.hidden=false;}else{peek.removeAttribute('src');peek.hidden=true;}
      root.querySelector('.rz-motion-peek').hidden = slides.length < 2;
      const peekButton = root.querySelector('.rz-motion-peek');
      if(!peekButton.dataset.baseLabel) peekButton.dataset.baseLabel = peekButton.getAttribute('aria-label');
      peekButton.querySelector('[data-rz-next-model]').textContent=nextSlide.dataset.model + (nextSlide.dataset.productId==='9220033478807'?' · White':nextSlide.dataset.productId==='9220148134039'?' · Yellow':'');
      peekButton.setAttribute('aria-label', peekButton.dataset.baseLabel + ': ' + nextSlide.dataset.navLabel);
      root.querySelector('[data-rz-count]').textContent = String(slides.indexOf(active)+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0');
      renderDots();
      status.textContent = active.dataset.model + '. ' + (slides.indexOf(active)+1) + ' / ' + slides.length;
      timer = setTimeout(() => slides.forEach(s => s.classList.remove('is-entering','is-leaving')), 900);
    }
    root.querySelectorAll('[data-rz-next]').forEach(b => b.addEventListener('click', () => advance(1)));
    root.querySelector('[data-rz-prev]').addEventListener('click', () => advance(-1));
    stage.addEventListener('keydown', e => {if(!e.ctrlKey&&!e.metaKey&&(e.key==='Home'||e.key==='End')){e.preventDefault();show(e.key==='Home'?0:group().length-1);return;}if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();advance(e.key==='ArrowRight'?1:-1);}});
    stage.addEventListener('dragstart', e => e.preventDefault());
    let lastWheel = 0;
    stage.addEventListener('wheel', e => {
      if(Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 8){
        e.preventDefault();
        if(Date.now() - lastWheel > 700){lastWheel=Date.now();advance(e.deltaX>0?1:-1);}
      }
    },{passive:false});
    stage.addEventListener('pointerdown', e => {
      if(e.button !== 0 || e.target.closest('button')) return;
      pointer={id:e.pointerId,x:e.clientX,y:e.clientY,dx:0,horizontal:false};dragged=false;
    });
    stage.addEventListener('pointermove', e => {
      if(!pointer || pointer.id!==e.pointerId)return;
      const dx=e.clientX-pointer.x,dy=e.clientY-pointer.y;
      if(!pointer.horizontal && Math.abs(dy)>12 && Math.abs(dy)>Math.abs(dx)){pointer=null;return;}
      if(Math.abs(dx)>9 && Math.abs(dx)>Math.abs(dy)){
        pointer.horizontal=true;dragged=true;stage.setPointerCapture(e.pointerId);
        stage.classList.add('is-dragging');root.style.setProperty('--drag',Math.max(-220,Math.min(220,dx))+'px');pointer.dx=dx;
      }
    });
    function release(e){
      if(!pointer || pointer.id!==e.pointerId)return;
      const dx=pointer.dx;pointer=null;stage.classList.remove('is-dragging');
      if(e.type!=='pointercancel' && Math.abs(dx)>45)advance(dx<0?1:-1);
      else root.style.setProperty('--drag','0px');
      setTimeout(()=>{dragged=false;},0);
    }
    stage.addEventListener('pointerup',release);stage.addEventListener('pointercancel',release);
    stage.addEventListener('click',e=>{if(dragged){e.preventDefault();e.stopPropagation();}},true);
    root.addEventListener('shopify:block:select',e=>{const s=e.target.closest('[data-rz-slide]');if(s){category=s.dataset.category;show(group().indexOf(s));}});
    show(0,1,false);
    root.dataset.catalogLoaded='curated';
  }
  const boot=()=>document.querySelectorAll('[data-rz-motion]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rz-campaign-showcase"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('[data-rz-campaign]');if(!button)return;const section=button.closest('[data-rz-engage]');if(!section)return;const active=button.dataset.rzCampaign;section.querySelectorAll('[data-rz-panel]').forEach(function(panel){panel.hidden=panel.dataset.rzPanel!==active;});section.querySelectorAll('[data-rz-campaign]').forEach(function(item){item.setAttribute('aria-pressed',String(item===button));});});
function rzUpdateGiftDemo(demo){const input=demo.querySelector('input[type=range]');const value=Number(input.value);const goal=Number(demo.dataset.goal);const money=function(n){return 'Rs. '+new Intl.NumberFormat('en-PK',{maximumFractionDigits:0}).format(n);};demo.querySelector('[data-rz-basket-value]').textContent=money(value);demo.querySelector('progress').value=Math.min(value,goal);demo.dataset.qualified=String(value>=goal);demo.querySelector('[data-rz-gift-status]').textContent=value>=goal?demo.dataset.reached:demo.dataset.remaining.replace('{amount}',money(goal-value));}
document.addEventListener('input',function(event){const demo=event.target.closest('[data-rz-gift-demo]');if(demo&&event.target.matches('input[type=range]'))rzUpdateGiftDemo(demo);});
document.addEventListener('click',function(event){const button=event.target.closest('[data-rz-example]');if(!button)return;const demo=button.closest('[data-rz-gift-demo]');demo.querySelector('input[type=range]').value=button.dataset.rzExample;rzUpdateGiftDemo(demo);});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rz-review-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.rz-campaign').forEach(function(hero){
 hero.querySelectorAll('.rz-campaign-controls button').forEach(function(button){
  button.addEventListener('click',function(){
   hero.querySelectorAll('.rz-campaign-controls button').forEach(function(tab){tab.setAttribute('aria-pressed',String(tab===button));});
   hero.querySelectorAll('.rz-campaign-slide').forEach(function(slide){slide.hidden=slide.id!==button.getAttribute('aria-controls');});
  });
 });
});

  } catch(e) { console.error(e); }
})();
})();
